import { Visit } from '../models/skyclub.interfaces';

export const SingleVisit: Visit = {
  count: 10,
  maxCount: 15,
  title: 'Visits Available',
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-amex-reserve-card-default.svg',
    alt: 'Delta SkyMiles Reserve Business Amex Card'
  }
};

export const SingleVisitDifferentCount: Visit = {
  count: 3,
  maxCount: 15,
  title: 'Visits Available',
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-amex-reserve-card-default.svg',
    alt: 'Delta SkyMiles Reserve Business Amex Card'
  }
};

export const UsedAllVisits: Visit = {
  title: 'You used all your visits',
  count: 15,
  maxCount: 15,
  description:
    'Get more for $50 per visit, or unlock Unlimited Access by spending $66,000 on your Card.',
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-zero-visit-card.svg',
    alt: 'Delta SkyMiles Reserve Business Amex Card'
  }
};

export const Unlimited75KVisits: Visit = {
  title: 'Unlimited Access',
  maxCount: 15,
  description:
    'Congratulations! You unlocked Unlimited Sky Club Access through January 31, 2027.',
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-unlocked-card.svg',
    alt: 'Delta SkyMiles Reserve Business Amex Card'
  }
};

export const UnlimitedAccessVisits: Visit = {
  title: 'Unlimited Access',
  maxCount: 15,
  description: 'Valid through January 31, 2027.',
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-amex-reserve-card-default.svg',
    alt: 'Delta SkyMiles Reserve Business Amex Card'
  }
};

export const MemberSkyClubVisits: Visit = {
  title: 'Unlimited Access',
  maxCount: 15,
  description: 'Valid through January 31, 2027.',
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/skyclub-unlimited-membership-card.svg',
    alt: 'Delta Sky Club Membership'
  }
};
